import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { FieldTree, FormField } from "@angular/forms/signals";
import {
  IErrorComponent,
  IFormFieldComponent,
  IIconComponent,
  IInputDirective,
  IInputGroupDirective,
  IInputGroupInput,
  IInputGroupSuffixDirective,
  ILabelComponent,
} from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";

export interface TacosCreateStrategySetupModel {
  name: string;
  tacosTarget: number | null;
}

@Component({
  selector: "app-tacos-create-strategy-setup",
  imports: [
    TranslocoDirective,
    IFormFieldComponent,
    ILabelComponent,
    IInputDirective,
    IErrorComponent,
    IInputGroupDirective,
    IInputGroupInput,
    IInputGroupSuffixDirective,
    IIconComponent,
    FormField,
  ],
  template: ` <div class="flex flex-col gap-8 py-8" *transloco="let t">
    <div class="flex flex-col gap-1">
      <h4>{{ t("strategy-form.setup_title") }}</h4>
      <p class="type-body text-muted-foreground m-0">{{ t("tacos-strategy.setup_description") }}</p>
    </div>
    <IFormField>
      <label iLabel>{{ t("common.name") }}</label>
      <input iInput [formField]="setup().name" size="sm" [placeholder]="t('common.name')" />
      <IError>{{ t("tacos-strategy.strategy_name_is_required") }}</IError>
    </IFormField>
    <IFormField>
      <label iLabel>{{ t("strategy-table.target") }}</label>
      <div iInputGroup>
        <input
          iInputGroupInput
          [formField]="setup().tacosTarget"
          size="sm"
          type="number"
          [placeholder]="t('strategy-table.target')"
        />
        <IIcon name="percent" iInputGroupSuffix />
      </div>
      <IError>{{ t("tacos-strategy-page.tacos_target_must_be_between_1_and_100") }}</IError>
    </IFormField>
  </div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TacosCreateStrategySetupComponent {
  readonly setup = input.required<FieldTree<TacosCreateStrategySetupModel>>();
}
